import { BetaFeature } from '../@types/BetaFeature.type';
import { useBetaAccessFlag } from '../customHooks/useBetaAccessFlag/useBetaAccessFlag';
import { BETA_FEATURES, getBetaFlagNames } from './betaFeatures';

/** Returns the beta features the current user is authorized to use. */
export const useAvailableBetaFeatures = (
  splitKey: string,
  features: BetaFeature[] = BETA_FEATURES,
) => {
  const { isFlagEnabled, isFlagLoading } = useBetaAccessFlag(
    splitKey,
    getBetaFlagNames(features),
  );

  const availableFeatures = features.filter((feature) =>
    isFlagEnabled(feature.flag),
  );

  return { availableFeatures, isLoading: isFlagLoading };
};
